import WelcomeFactory from "./welcomeFactory";
export default WelcomeFactory(
  "WELCOME_PANEL_4_TITLE",
  "WELCOME_PANEL_4_TEXT",
  "JobFunction",
  "WELCOME_GETSTARTED",
  require("../../assets/img/welcome/welcome4.png")
);
